import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      display: "flex",
      flexDirection: "row",
      userSelect: "none",
    },
    left: {
      flexGrow: 1,
    },
    right: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    shared: {
      border: `1px solid ${theme.shared.badge.default}`,
      padding: `${spacing.xxxs}px ${spacing.xxs}px`,
      borderRadius: 4,
      borderTopRightRadius: 50,
      borderBottomRightRadius: 50,
      display: "inline-block",
    },
    sharedText: {
      color: theme.shared.badge.default,
      fontWeight: 500,
    },
    contact: {
      marginLeft: spacing.xs,
      backgroundColor: theme.contact.item1,
      borderRadius: constants.radius.button,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: `2px 3px`,
    },
    contactText: {
      fontWeight: 600,
    },
  };

  return styles;
};
